(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[231],{

/***/ 20235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luxury-hotels-membership",
      function () {
        return __webpack_require__(80254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CheckIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.6851 25.9723L1.21741 16.1429L4.00269 13.2512L10.6851 20.189L27.215 3.02773L30 5.91939L10.6851 25.9723Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckIcon);


/***/ }),

/***/ 3967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13.6464 0.646423L0.646423 13.6464L0.999977 14L1.35353 14.3536L14.3536 1.35353L14 0.999977L13.6464 0.646423Z",
                    fill: "#191919",
                    stroke: "#505050"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.5848 0.877258L14.3575 13.65L14.0038 14.0037L13.6501 14.3573L0.877502 1.58456L1.23115 1.23091L1.5848 0.877258Z",
                    fill: "#191919",
                    stroke: "#505050"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIcon);


/***/ }),

/***/ 80254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ luxury_hotels_membership; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/icons/CheckIcon.tsx
var CheckIcon = __webpack_require__(18570);
// EXTERNAL MODULE: ./components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(3967);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useJoinUs/useJoinUs.ts
var useJoinUs = __webpack_require__(1698);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./services/CurrencyDisplay/CurrencyDisplay.ts
var CurrencyDisplay = function(param) {
    var language = param.language, currency = param.currency, value = param.value;
    language = language || "en-UK";
    if (currency === "USD") {
        return Intl.NumberFormat(language, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 0,
            currencyDisplay: "narrowSymbol"
        }).format(value);
    }
    if (currency === "EUR") {
        return Intl.NumberFormat(language, {
            style: "decimal",
            currency: currency,
            minimumFractionDigits: 0
        }).format(value) + "€";
    }
    return Intl.NumberFormat(language, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0
    }).format(value);
};
/* harmony default export */ var CurrencyDisplay_CurrencyDisplay = (CurrencyDisplay);

// EXTERNAL MODULE: ./services/MembershipService/MembershipService.ts
var MembershipService = __webpack_require__(44653);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./utils/membership.ts


/**
 * Adds the currency symbol and selects the current currency
 *
 * Looks for: ::Currency::{USD=25|EUR=25|GBP=20|HKD=200}
 * Returns: £20
 */ var currencyHandler = function(text, currentCurrency) {
    var trigger = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "::Currency::";
    var regex = /{([^}]+)}/g;
    var matches = text.match(regex);
    if (!matches) text;
    var newText = text;
    matches === null || matches === void 0 ? void 0 : matches.map(function(match) {
        var keyValuePairs = match.substring(1, match.length - 1).split("|");
        keyValuePairs.forEach(function(pair) {
            var ref = (0,_sliced_to_array/* default */.Z)(pair.split("="), 2), key = ref[0], value = ref[1];
            if (key === currentCurrency) {
                newText = newText.replace(trigger + match, CurrencyDisplay_CurrencyDisplay({
                    currency: key,
                    value: parseInt(value)
                }));
            }
        });
    });
    return newText;
};

;// CONCATENATED MODULE: ./blocks/CompareMembership/CompareMembership.tsx


















var CompareMembership = function(param) {
    var memberships = param.memberships, features = param.features, currencies = param.currencies;
    var ref = (0,react.useContext)(useJoinUs/* JoinUsContext */.L), state = ref.joinUsState, setState = ref.setState;
    var compare_membership_text = (0,useLocalised/* default */.Z)(translationKeys.compare_membership);
    var compare_membership_description_text = (0,useLocalised/* default */.Z)(translationKeys.compare_membership_description);
    (0,react.useEffect)(function() {
        if (!currencies || currencies.length === 0) {
            return;
        }
        var setDefaultValues = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var defaultCurrency;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                MembershipService/* default.getDefaultCurrency */.Z.getDefaultCurrency(currencies)
                            ];
                        case 1:
                            defaultCurrency = _state.sent();
                            setState(function(state) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    currency: defaultCurrency.code
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function setDefaultValues() {
                return _ref.apply(this, arguments);
            };
        }();
        setDefaultValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var selectedCurrency = (0,react.useMemo)(function() {
        var selectedCurrencyCode = state.currency;
        return currencies.find(function(param) {
            var code = param.code;
            return code === selectedCurrencyCode;
        });
    }, [
        currencies,
        state.currency
    ]);
    var openDialogue = (0,react.useContext)(useDialogue/* DialogueContext */.$).openDialogue;
    var handleSelectMembership = (0,react.useCallback)(function(membershipId) {
        var membership = memberships.find(function(param) {
            var id = param.id;
            return id === membershipId;
        });
        var price = membership === null || membership === void 0 ? void 0 : membership.prices.find(function(param) {
            var code = param.code;
            return code === state.currency;
        });
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                membershipId: membershipId,
                price: price
            });
        });
        openDialogue(constants/* JOIN_US_DIALOG_STEP_2 */.pn);
    }, [
        memberships,
        setState,
        openDialogue,
        state.currency
    ]);
    var getFormattedPrice = function(prices) {
        var ref;
        return CurrencyDisplay_CurrencyDisplay({
            currency: (state === null || state === void 0 ? void 0 : state.currency) || "GBP",
            value: Number((ref = prices.find(function(price) {
                return price.code === ((state === null || state === void 0 ? void 0 : state.currency) || "GBP");
            })) === null || ref === void 0 ? void 0 : ref.value.replace(",", ""))
        });
    };
    var ref1 = (0,react.useState)(null), hoveredColumn = ref1[0], setHoveredColumn = ref1[1];
    var handleMouseEnter = function(columnIndex) {
        setHoveredColumn(columnIndex);
    };
    var handleMouseLeave = function() {
        setHoveredColumn(null);
    };
    var isColumnHighlighted = function(columnIndex) {
        return hoveredColumn === columnIndex;
    };
    var tableMembershipHeadColumns = memberships.map(function(membership, index) {
        var image = membership.image, name = membership.name, description = membership.description, prices = membership.prices;
        var price = getFormattedPrice(prices);
        var colContainerClassName = "col-container ".concat(isColumnHighlighted(index) ? "col-highlight" : "");
        var colKey = "".concat(index, "_col_membership_head");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            scope: "col",
            onMouseEnter: function() {
                return handleMouseEnter(index);
            },
            onMouseLeave: handleMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: colContainerClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(image),
                        alt: "alt",
                        width: 640,
                        height: 436
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "membership-plans-title",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "membership-plans-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "membership-plans-price-duration",
                                children: "per year"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "membership-plans-description",
                        children: description
                    })
                ]
            })
        }, colKey);
    });
    var tableMembershipFeatureRows = features.map(function(feature, rowIndex) {
        var featureTitle = feature.title;
        var featureDescription = feature.description;
        var rowKey = "".concat(rowIndex, "_row_feature");
        featureDescription = featureDescription.includes("::Currency::") ? currencyHandler(featureDescription, selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.code) : featureDescription;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "row",
                    className: "membership-feature-row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "membership-feature-row-title",
                                children: featureTitle
                            }),
                            featureDescription
                        ]
                    })
                }),
                memberships.map(function(membership, colIndex) {
                    var membershipId = membership.id;
                    var featureMemberships = feature.memberships;
                    var hasMembershipFeature = featureMemberships.find(function(item) {
                        return item.plan === membershipId;
                    });
                    var colContainerClassName = "col-container ".concat(isColumnHighlighted(colIndex) ? "col-highlight" : "");
                    var cellTitleClassName = "membership-feature-cell-title ".concat(!hasMembershipFeature && "color-inactive");
                    var cellSumaryClassName = "membership-feature-cell-sumary ".concat(!hasMembershipFeature && "color-inactive");
                    var cellFeatureContent = !hasMembershipFeature ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                        className: "icon-no-has-feature"
                    }) : hasMembershipFeature.text !== "" ? hasMembershipFeature.text : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {});
                    var colKey = "".concat(colIndex, "_col_membership");
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        scope: "col",
                        className: "membership-feature-row",
                        onMouseEnter: function() {
                            return handleMouseEnter(colIndex);
                        },
                        onMouseLeave: handleMouseLeave,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: colContainerClassName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "membership-feature-cell",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: cellTitleClassName,
                                                children: featureTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "has-feature",
                                                children: cellFeatureContent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: cellSumaryClassName,
                                        children: featureDescription
                                    })
                                ]
                            })
                        })
                    }, colKey);
                })
            ]
        }, rowKey);
    });
    var tableMembershipButtonColumns = memberships.map(function(membership, index) {
        var buttonBackground = membership.button_background, buttonColor = membership.button_color, membershipId = membership.id;
        var handleButtonClick = function() {
            handleSelectMembership(membershipId);
        };
        var colContainerClassName = "col-container ".concat(isColumnHighlighted(index) ? "col-highlight" : "");
        var buttonHtmlAttributes = {
            style: {
                backgroundColor: buttonBackground,
                color: buttonColor
            }
        };
        var colKey = "".concat(index, "_col_membership_button");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
            scope: "col",
            className: "membership-button-cell",
            onMouseEnter: function() {
                return handleMouseEnter(index);
            },
            onMouseLeave: handleMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: colContainerClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    title: "Become a member",
                    onClick: handleButtonClick,
                    className: "membership-button-become",
                    buttonType: Button/* FILLED_BUTTON_TYPE_DARK */.HB,
                    htmlAttributes: buttonHtmlAttributes
                })
            })
        }, colKey);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "compare-membership-background",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "compare_membership",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "compare_membership__title",
                        children: compare_membership_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "compare_membership__top_text",
                        children: compare_membership_description_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "membership-plans-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "wrap-table",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                    className: "membership-plans",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                                    tableMembershipHeadColumns
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                            children: tableMembershipFeatureRows
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                                                    tableMembershipButtonColumns
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CompareMembership_CompareMembership = (CompareMembership);

// EXTERNAL MODULE: ./blocks/DownloadApp/DownloadApp.tsx + 2 modules
var DownloadApp = __webpack_require__(31968);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
;// CONCATENATED MODULE: ./assets/membership_background.jpeg
/* harmony default export */ var membership_background = ({"src":"/_next/static/media/membership_background.7ca68d2b.jpeg","height":1920,"width":2560,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQQGITNRYf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACEf/aAAwDAQACEQMRAD8AnsyHR6LJfwmIsEbdrIs2T14iIp8k/Vv/2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./blocks/MembershipHero/MembershipHero.tsx






var MembershipHero = function() {
    var lowest_price_title_text = (0,useLocalised/* default */.Z)(translationKeys.lowest_price_title);
    var lowest_price_description_text = (0,useLocalised/* default */.Z)(translationKeys.lowest_price_description);
    var book_with_benefits_title_text = (0,useLocalised/* default */.Z)(translationKeys.book_with_benefits_title);
    var book_with_benefits_description_text = (0,useLocalised/* default */.Z)(translationKeys.book_with_benefits_description);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "membership-hero",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "membership-hero__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: membership_background,
                    alt: "background image",
                    // width={1300}
                    width: 2560,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "membership-hero__container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "membership-hero__card membership-hero__price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "membership-hero__card-title",
                                children: lowest_price_title_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "membership-hero__card-text",
                                children: lowest_price_description_text
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "membership-hero__card membership-hero__benefits",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "membership-hero__card-title",
                                children: book_with_benefits_title_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "membership-hero__card-text",
                                children: book_with_benefits_description_text
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MembershipHero_MembershipHero = (MembershipHero);

;// CONCATENATED MODULE: ./data/memberships.json
var memberships_namespaceObject = JSON.parse('{"O":[{"id":"travel","name":"Travel","prices":[{"code":"EUR","value":"300","symbol":"€"},{"code":"GBP","value":"250","symbol":"£"},{"code":"USD","value":"325","symbol":"$"},{"code":"HKD","value":"2500","symbol":"HK$"}],"description":"The perfect travel companion for the global jetsetter bringing the best value to luxury travel","image":"/images/silver_membership.png","button_color":"#191919","button_background":"#E3E3E3"},{"id":"black","name":"Black","prices":[{"code":"EUR","value":"1200","symbol":"€"},{"code":"GBP","value":"1000","symbol":"£"},{"code":"USD","value":"1300","symbol":"$"},{"code":"HKD","value":"10000","symbol":"HK$"}],"description":"Book unlimited preferential rates when you’re present, enjoy priority upgrades, no booking fees ","image":"/images/black_membership.png","button_color":"#fff","button_background":"#404040"},{"id":"dynasty","name":"Dynasty","prices":[{"code":"EUR","value":"1800","symbol":"€"},{"code":"GBP","value":"1500","symbol":"£"},{"code":"USD","value":"1950","symbol":"$"},{"code":"HKD","value":"15000","symbol":"HK$"}],"description":"Book for anyone, any time and share Travel Tier memberships with your friends and family","image":"/images/gold_membership.png","button_color":"#191919","button_background":"#BAA57E"}],"R":[{"title":"Little Emperors preferential rates","description":"At over half the hotel collection for the named member","memberships":[{"plan":"travel","text":"One room per booking"},{"plan":"black","text":"Unlimited"},{"plan":"dynasty","text":"Unlimited"}]},{"title":"Rates with complimentary benefits","description":"Breakfast, hotel credits, spa treatments, experiences and more","memberships":[{"plan":"travel","text":"Unlimited"},{"plan":"black","text":"Unlimited"},{"plan":"dynasty","text":"Unlimited"}]},{"title":"Hotel upgrades","description":"Guaranteed upgrades either at time of booking or check in","memberships":[{"plan":"travel","text":""},{"plan":"black","text":"Priority"},{"plan":"dynasty","text":"Priority"}]},{"title":"Friends & Family","description":"Book non-preferential rates for friends and family, whether you\'re travelling or not","memberships":[{"plan":"travel","text":""},{"plan":"black","text":""},{"plan":"dynasty","text":""}]},{"title":"Flexible rates","description":"Same cancellation, payment and loyalty point collection as when booking with the hotel directly","memberships":[{"plan":"travel","text":""},{"plan":"black","text":""},{"plan":"dynasty","text":""}]},{"title":"Booking fee","description":"::Currency::{USD=25|EUR=25|GBP=20|HKD=200} fixed booking fee per room with no hidden costs","memberships":[{"plan":"travel","text":""},{"plan":"black","text":"No booking fees"},{"plan":"dynasty","text":"No booking fees"}]},{"title":"Lifestyle offers","description":"Money off car hire, private jets and more","memberships":[{"plan":"travel","text":""},{"plan":"black","text":""},{"plan":"dynasty","text":""}]},{"title":"Events","description":"Access to exclusive tickets to some of the world’s most sought after events","memberships":[{"plan":"travel","text":""},{"plan":"black","text":""},{"plan":"dynasty","text":""}]},{"title":"Share memberships","description":"Provide complimentary Travel Tier memberships to your network","memberships":[{"plan":"dynasty","text":""}]}]}');
;// CONCATENATED MODULE: ./pages/luxury-hotels-membership.tsx








var Membership = function(param) {
    var globalLayoutProps = param.globalLayoutProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipHero_MembershipHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareMembership_CompareMembership, {
                memberships: memberships_namespaceObject.O.map(function(membership) {
                    var ref;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, membership), {
                        prices: ((ref = globalLayoutProps.memberships.find(function(globalMembership) {
                            return globalMembership.id === membership.id;
                        })) === null || ref === void 0 ? void 0 : ref.prices) || membership.prices
                    });
                }),
                features: memberships_namespaceObject.R,
                currencies: globalLayoutProps.currencies
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {})
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var luxury_hotels_membership = (Membership);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,1608,4520,9510,9774,2888,179], function() { return __webpack_exec__(20235); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);